import React from 'react';
import { links } from './constants';
import CoulmnLinks from './columns-links';
import ExpandableFooterLinks from './expandable-links';
export default function columns() {
  return <div className='order-2 lg:order-1' data-sentry-component="columns" data-sentry-source-file="columns.tsx">
            <div className='hidden grid-cols-2 gap-6 lg:grid'>
                {links.reverse().map(link => {
        return <div key={link.collection[0].title} className='flex flex-col gap-8'>
                            <span className='text-base font-bold text-white'>{link.title}</span>
                            <CoulmnLinks collection={link.collection} />
                        </div>;
      })}
            </div>
            <ExpandableFooterLinks data-sentry-element="ExpandableFooterLinks" data-sentry-source-file="columns.tsx" />
        </div>;
}